import axiosInstance from "../utils/axiosInstance";

// Company Documents. The company is always taken from the auth token on the
// server — nothing here sends a company id.

// status: "active" (default) | "archived" (admins only; employees always get active)
export async function fetchCompanyDocuments(status = "active") {
  const { data } = await axiosInstance.get(`/company-documents`, {
    params: status === "archived" ? { status } : {},
  });
  return Array.isArray(data?.data) ? data.data : [];
}

// Short-lived signed link, issued only after the server re-checks ownership.
export async function getCompanyDocumentUrl(id) {
  const { data } = await axiosInstance.get(`/company-documents/${id}/url`);
  return data?.data;
}

// ---------- Employee ----------
// Confirms the caller has read the current file. They must have opened it first.
export async function acknowledgeCompanyDocument(id) {
  const { data } = await axiosInstance.post(`/company-documents/${id}/acknowledge`);
  return data?.data;
}

// ---------- Admin ----------
// { document, employees: [{ _id, name, employee_code, department, status, opened_at, acknowledged_at }] }
export async function fetchCompanyDocumentAcknowledgements(id) {
  const { data } = await axiosInstance.get(`/company-documents/${id}/acknowledgements`);
  return data?.data;
}

// { sent }
export async function remindCompanyDocumentAcknowledgements(id) {
  const { data } = await axiosInstance.post(`/company-documents/${id}/acknowledgements/remind`);
  return data?.data;
}

// { departments_enabled, departments: string[], employees: [{ _id, name, employee_code, department }] }
export async function fetchCompanyDocumentAudienceOptions() {
  const { data } = await axiosInstance.get(`/company-documents/audience-options`);
  return data?.data;
}

// formData: file, title, description, category, audience (JSON string)
export async function uploadCompanyDocument(formData) {
  const { data } = await axiosInstance.post(`/company-documents`, formData);
  return data?.data;
}

export async function updateCompanyDocument(id, payload) {
  const { data } = await axiosInstance.patch(`/company-documents/${id}`, payload);
  return data?.data;
}

// formData: file
export async function replaceCompanyDocumentFile(id, formData) {
  const { data } = await axiosInstance.put(`/company-documents/${id}/file`, formData);
  return data?.data;
}

export async function archiveCompanyDocument(id) {
  const { data } = await axiosInstance.patch(`/company-documents/${id}/archive`);
  return data?.data;
}

export async function restoreCompanyDocument(id) {
  const { data } = await axiosInstance.patch(`/company-documents/${id}/restore`);
  return data?.data;
}

export async function deleteCompanyDocument(id) {
  const { data } = await axiosInstance.delete(`/company-documents/${id}`);
  return data?.data;
}
